module.exports = __webpack_public_path__ + "resources/img/sp_solution_app.6ec87ce435fcbc6ad65cf75d282832bf.png";